import { useEffect, useState } from 'react'

export function useDebounce<T>(initial?: T, timeout = 300) {
  const [value, setValue] = useState<T | undefined>(initial)
  const [debounceValue, setDebounceValue] = useState<T | undefined>(initial)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceValue(value)
    }, timeout)

    return () => clearTimeout(timer)
  }, [value])

  return { value, setValue, debounceValue }
}

export function useDebounce_new<T>(value: T, timeout = 300) {
  const [debounceValue, setDebounceValue] = useState<T | undefined>(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceValue(value)
    }, timeout)

    return () => clearTimeout(timer)
  }, [value])

  return debounceValue
}
